import { Action, combineReducers } from "redux";
import * as store from "../../../framework/customStore";
import { TDefaultListFilter } from "../../common/defaultListFilter";
import { IEventPage } from "../../event/eventPage";

// State
export interface IEventPageState {
    dataId: number;
    eventPage: IEventPage;
}

export interface IEventListState {
    defaultFilter: TDefaultListFilter;
}

export interface IEventState {
    page: IEventPageState;
    list: IEventListState;
}

// Action type constants
const EVENT_SUCCESS = "EVENT_SUCCESS";
const EVENT_FAILURE = "EVENT_FAILURE";

const EVENT_SUCCESS_LIST_SET_DEFAULT_FILTER = "EVENT_SUCCESS_LIST_SET_DEFAULT_FILTER";

type T_EVENT_SUCCESS = typeof EVENT_SUCCESS;
type T_EVENT_FAILURE = typeof EVENT_FAILURE;

type T_EVENT_SUCCESS_LIST_SET_DEFAULT_FILTER = typeof EVENT_SUCCESS_LIST_SET_DEFAULT_FILTER;

// Action types
interface IEventSuccess extends Action {
    type: T_EVENT_SUCCESS;
    eventPage: IEventPage;
}

interface IEventFailure extends Action {
    type: T_EVENT_FAILURE;
}

interface IEventListSetDefaultFilter extends Action {
    type: T_EVENT_SUCCESS_LIST_SET_DEFAULT_FILTER;
    defaultFilter: TDefaultListFilter;
}

export type EventAction =
    | IEventSuccess
    | IEventFailure
    | IEventListSetDefaultFilter;

//Actions
export const eventSuccess = (eventPage: IEventPage): IEventSuccess => ({
    type: EVENT_SUCCESS,
    eventPage
});

export const eventFailure = (): IEventFailure => ({
    type: EVENT_FAILURE
});

export const eventListSetDefaultFilter = (defaultFilter: TDefaultListFilter): IEventListSetDefaultFilter => ({
    type: EVENT_SUCCESS_LIST_SET_DEFAULT_FILTER,
    defaultFilter
});

//Reducers
export const eventInitialState: IEventState = {
    page: {
        dataId: 0,
        eventPage: null
    },
    list: {
        defaultFilter: null
    }
};

const page = (state: IEventPageState = null, action: EventAction) => {
    switch (action.type) {
    case EVENT_SUCCESS: {
        const eventSuccess = action as IEventSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            eventPage: eventSuccess.eventPage
        };
    }
    case EVENT_FAILURE:
        return { ...state };
    }
    return state;
};

const list = (state: IEventListState = null, action: EventAction) => {
    switch (action.type) {
    case EVENT_SUCCESS_LIST_SET_DEFAULT_FILTER: {
        const listDefaultFilter = action as IEventListSetDefaultFilter;
        return {
            ...state,
            defaultFilter: listDefaultFilter.defaultFilter
        };
    }
    }
    return state;
};

//Root reducer
export const eventReducer = combineReducers({
    page,
    list
});

//Utils
export const setEventListDefaultFilter = (defaultFilter: TDefaultListFilter) => {
    store.customStore.dispatch(eventListSetDefaultFilter(defaultFilter));
};
